/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BasisOfCoverResponseDto
 */
export interface BasisOfCoverResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BasisOfCoverResponseDto
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof BasisOfCoverResponseDto
     */
    category: BasisOfCoverResponseDtoCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof BasisOfCoverResponseDto
     */
    basisOfCover: BasisOfCoverResponseDtoBasisOfCoverEnum;
}


/**
 * @export
 */
export const BasisOfCoverResponseDtoCategoryEnum = {
    Flood: 'Flood',
    Earthquake: 'Earthquake',
    Wind: 'Wind',
    Fire: 'Fire'
} as const;
export type BasisOfCoverResponseDtoCategoryEnum = typeof BasisOfCoverResponseDtoCategoryEnum[keyof typeof BasisOfCoverResponseDtoCategoryEnum];

/**
 * @export
 */
export const BasisOfCoverResponseDtoBasisOfCoverEnum = {
    AnyOneEvent: 'Any One Event',
    AnyOneLocation: 'Any One Location',
    InTheAggregate: 'In the Aggregate'
} as const;
export type BasisOfCoverResponseDtoBasisOfCoverEnum = typeof BasisOfCoverResponseDtoBasisOfCoverEnum[keyof typeof BasisOfCoverResponseDtoBasisOfCoverEnum];


/**
 * Check if a given object implements the BasisOfCoverResponseDto interface.
 */
export function instanceOfBasisOfCoverResponseDto(value: object): value is BasisOfCoverResponseDto {
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('basisOfCover' in value) || value['basisOfCover'] === undefined) return false;
    return true;
}

export function BasisOfCoverResponseDtoFromJSON(json: any): BasisOfCoverResponseDto {
    return BasisOfCoverResponseDtoFromJSONTyped(json, false);
}

export function BasisOfCoverResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasisOfCoverResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'submissionId': json['submissionId'],
        'category': json['category'],
        'basisOfCover': json['basisOfCover'],
    };
}

export function BasisOfCoverResponseDtoToJSON(json: any): BasisOfCoverResponseDto {
    return BasisOfCoverResponseDtoToJSONTyped(json, false);
}

export function BasisOfCoverResponseDtoToJSONTyped(value?: BasisOfCoverResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissionId': value['submissionId'],
        'category': value['category'],
        'basisOfCover': value['basisOfCover'],
    };
}

